export { default } from './QuizAscInput';



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/CheckTaskInputs/CheckTypeQuiz/QuizAscInput/index.js